import { ArticleWithMediaCount } from "../types/article";
import { ArticleListItemCardDesktop, MediaListDesktop } from "../styles/styles";
import { MediasViewSearchListItemSkeleton } from "../Molecules/MediasViewSearchListItemSkeleton";
import { TaskLinks } from "../types/taskLink";
import { useEDSData } from "../hooks/useEDSData";
import { useCountryId } from "../../../core/auth/useLoggedInUser";
import { joinProductArticleIds } from "../tools";
import { useSalesStopData } from "../hooks/useSalesStopData";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { ItemListViewItemSearch } from "@coworker/apprestructured/src/media-maintenance/components/ItemListViewItemSearch/ItemListViewItemSearch";

interface MediasViewArticleListDesktopProps {
  articles: ArticleWithMediaCount[] | undefined;
  taskLinks: TaskLinks;
  storeId: string;
}

export const MediasViewArticleListDesktop = ({
  articles,
  taskLinks,
  storeId,
}: MediasViewArticleListDesktopProps) => {
  const countryId = useCountryId();
  const articleNumbers = joinProductArticleIds(articles ?? []);
  const { data: edsData } = useEDSData(countryId, articleNumbers);
  const { data: salesStopData } = useSalesStopData(storeId, articleNumbers);

  if (!articles) {
    return (
      <FixaListView id="articles-list">
        <MediasViewSearchListItemSkeleton key="medias-view-article-0" />
        <MediasViewSearchListItemSkeleton key="medias-view-article-1" />
        <MediasViewSearchListItemSkeleton key="medias-view-article-2" />
        <MediasViewSearchListItemSkeleton key="medias-view-article-3" />
      </FixaListView>
    );
  } else {
    return (
      <MediaListDesktop>
        {articles &&
          articles.map((article, index) => (
            <ArticleListItemCardDesktop key={`${article.id}-${index}`}>
              <ItemListViewItemSearch
                article={article}
                taskLinks={taskLinks}
                edsData={
                  edsData?.find(
                    (eds: { productArticleId: string }) =>
                      eds.productArticleId === article.productArticleId
                  ) ?? null
                }
                salesStopData={
                  salesStopData?.find(
                    (salesStop) =>
                      salesStop.productArticleId === article.productArticleId
                  ) ?? null
                }
              />
            </ArticleListItemCardDesktop>
          ))}
      </MediaListDesktop>
    );
  }
};
